export const BILLING_PAGE = '/billing';

export const BILLING_DASHBOARD_ROUTE = 'dashboard';
export const BILLING_TRANSACTIONS_ROUTE = 'transactions';
export const BILLING_TOP_UP_RESULT_ROUTE = 'top-up/result';
export const BILLING_BONUSES_ROUTE = 'bonus';

export const BILLING_DASHBOARD_PAGE = `${BILLING_PAGE}/${BILLING_DASHBOARD_ROUTE}`;
export const BILLING_TRANSACTIONS_PAGE = `${BILLING_PAGE}/${BILLING_TRANSACTIONS_ROUTE}`;
export const BILLING_TOP_UP_RESULT = `${BILLING_PAGE}/${BILLING_TOP_UP_RESULT_ROUTE}`;
export const BILLING_BONUSES = `${BILLING_PAGE}/${BILLING_BONUSES_ROUTE}`;
